<template>
    <div class="naviConfig">
        <div class="maps">
            <div class="map">
                <HausNavigation></HausNavigation>
                <MapCanvas v-if="showRoute" :startpoint="startpoint" :endpoint="endpoint" :nodes="nodes"></MapCanvas>
                <div class="nodes" v-if="ShopNodesActive">
                    <div class="node"  v-on:click="opendrop(node)" :data-id="node.id" v-for="(node, key) in nodes" v-bind:key="key" v-bind:style="{left: node.x + 'px', top: node.y + 'px'}">
                        <!--                        <input class="drag" v-model="node.id">-->
                        <div class="drag" :class="{'isopen' : node.isOpen, 'isstart' : node.isStartpoint}"></div>
                        <div class="droptrigger" >></div>
                    </div>
                </div>
                <div class="service-points" v-if="ServicePointsActive">
                    <div class="point" >
                        <ServicePoint v-on:delete="deleteServicePoint(point)" :configMode="true" :dataid="point.id" :type="point.type" :position="point.position" v-for="(point, key) in filteredServicePoints" v-on:changeServicePoint="point.type = $event"></ServicePoint>
                    </div>
                </div>
            </div>
            <div id="nodemap"></div>

        </div>
        <div class="controls">
            <div class="panel">
                <h4>Navigate</h4>
                start:<input v-model="startpoint" placeholder="startpoint" type="text">
                end:<input v-model="endpoint" placeholder="endpoint" type="text">
                <button v-on:click="route">Route</button>
                <button v-on:click="clear">Clear</button>
                <br>
                <button v-on:click="addNode">Add Node</button>
                <button v-on:click="addServicePoint">Add Service Point</button>
                <button v-on:click="save">Save</button>
                <button v-on:click="load">Load</button>
                <p>{{currentRoute}}</p>
                <h4>Active Houses</h4>
                <p>{{activeHouses}}</p>
            </div>
            <div class="panel">
                <h4>Layers</h4>
                <div class="checkbox-container">
                    <input type="checkbox" v-model="ShopNodesActive"><label>Navigation Nodes</label>
                </div>
                <div class="checkbox-container">
                    <input type="checkbox" v-model="ServicePointsActive"><label>Service Points</label><br>
                    <input type="radio" v-model="activeServicePoints" value="lift">Lift<br>
                    <input type="radio" v-model="activeServicePoints" value="bank">Bank<br>
                    <input type="radio" v-model="activeServicePoints" value="lock">lock<br>
                    <input type="radio" v-model="activeServicePoints" value="info">info<br>
                    <input type="radio" v-model="activeServicePoints" value="toilet">Toilet<br>
                    <input type="radio" v-model="activeServicePoints" value="parkdeck">Parkdeck<br>

                </div>
                <div class="checkbox-container">
                    <input type="checkbox" v-model="EntrancesActive"><label>Entrances</label>
                </div>
                <br>
                <h4>Master Bump</h4>
                <div class="up" @click="masterBump('y', -1)">up </div>
                <div class="down" @click="masterBump('y', 1)">down</div>
                <div class="up" @click="masterBump('x', -1)">left </div>
                <div class="down" @click="masterBump('x', 1)">right</div>

            </div>
            <div class="panel">
                <h4>Selected Node</h4>
                <p><input type="checkbox" v-model="selectedNode.isStartpoint">Is Startpoint</p>
                <p>id: <input v-model="selectedNode.id" type="text"></p>
                <p>slug: <input v-model="selectedNode.slug" type="text"></p>
                <p>orientation: <input v-model="selectedNode.orientation" type="text"></p>

                <div v-on:click="deleteNode(selectedNode)">Delete</div><br>
                <div class="children">
                    Children:
                    <div class="child" v-for="(child, key) in selectedNode.children">
                        {{key}} <input type="number">  <span style="color: red" v-on:click="deleteChild(selectedNode, key)">x</span>
                    </div>
                    <div>Add Child:</div>
                    <select v-on:change="addChild(selectedNode)" v-model="newChild">
                        <option v-for="(node) in sortedNodes" v-bind:value="node.id">
                            {{ node.id }}
                        </option>
                    </select>
                </div>

                <div class="childOrientation">
                    Child orientation
                    <div class="child" v-for="(child, key) in selectedNode.childOrientation">
                        {{child.node}} <input type="text" v-model="child.orientation">
                    </div>
                </div>
            </div>
        </div>
        <div class="output">
            <h4>Navigation Nodes</h4>
            <div v-html="JSON.stringify(nodes)"></div>
        </div>
        <div class="output">
            <h4>Service Points</h4>
            <div v-html="servicePoints"></div>
        </div>

    </div>
</template>

<script>
// @ is an alias to /src
import Advertising from "@/components/Advertising";
import HausNavigation from '@/components/HouseNavigation.vue'
import Node from '@/components/NaviConfig/Node.vue'
import MapCanvas from "@/components/MapCanvas";
import interact from 'interactjs'
import Konva from 'konva'
import Vue from 'vue';
import ServicePoint from "@/components/ServicePoint";
import * as nodelib from '@/nodes.js'
import axios from "axios";
export default {
    name: 'NaviConfig',
    components: {
        Advertising, HausNavigation, Node, MapCanvas, ServicePoint
    },
    data(){
        return {
            mapWidth: 800,
            mapHeight: 1000,
            newChild: '',
            startpoint: 'h11',
            endpoint: 'h25',
            showRoute: false,
            nodes: [],
            servicePoints: [ ],
            selectedNode: false,
            selectedServicePoint: false,
            ShopNodesActive: true,
            ServicePointsActive: false,
            activeServicePoints: 'bank',
            EntrancesActive: false,
            routes: [],
        }
    },
    computed: {
        // selectedNode(){
        //     return this.nodes.find(x=> x.isOpen == true)
        // }
        sortedNodes(){
            return this.nodes.sort(function (a,b) {
                return a.id.localeCompare(b.id);
            })
        },
        filteredServicePoints(){
            return this.servicePoints.filter(x=> x.type == this.activeServicePoints)
        },
        currentRoute(){
            return this.routes[this.endpoint];
        },
        activeHouses(){
            // return nodelib.getActiveHouses(this.startpoint, this.endpoint)
        },
    },
    created() {
        // load
        this.nodes = nodelib.nodes;
        this.servicePoints = nodelib.servicePoints;
        // this.startDescriptionsOLD = nodelib.startDescriptionsOLD;

        // Drag n Drop
        let v = this;
        interact('.node .drag').draggable({
            listeners: {
                start (event) {
                    // console.log(event.type, event.target)
                },
                move (event) {
                    let node = v.nodes.find(x=>x.id == event.target.parentElement.getAttribute('data-id'));
                    node.x += event.dx
                    node.y += event.dy
                    console.log(node.x)
                },
                end(event){
                    v.drawGraph();
                }

            }
        })

        interact('.service-point .icon').draggable({
            listeners: {
                start (event) {
                    // console.log(event.type, event.target)
                },
                move (event) {
                    // let node = v.servicePoints.find(x=> x.id == event.target.getAttribute('data-id'));
                    let node = v.servicePoints[event.target.getAttribute('data-id')];
                    node.position.x += event.dx
                    node.position.y += event.dy
                },
                end(event){
                    // v.drawGraph();
                }

            }
        })


    },
    mounted(){
        this.drawGraph()

        document.addEventListener('keydown', event => {
            let caught = false;
            if ( event.keyCode == 37 ){
                if (this.selectedNode){
                    this.selectedNode.x --;
                    caught = true;
                }
            }
            if ( event.keyCode == 39 ){
                if (this.selectedNode){
                    this.selectedNode.x ++;
                    caught = true;
                }
            }
            if ( event.keyCode == 40 ){
                if (this.selectedNode){
                    this.selectedNode.y ++;
                    caught = true;
                }
            }
            if ( event.keyCode == 38 ){
                if (this.selectedNode){
                    this.selectedNode.y --;
                    caught = true;
                }
            }

            if (caught){
                event.preventDefault();
                this.drawGraph();
            }


            return false;
        })
    },
    watch: {

    },
    methods: {
        route(){
            this.clear()
            this.showRoute = true
            this.routes = nodelib.navigate(this.startpoint);
        },
        clear(){
            this.showRoute = false
        },
        addNode(){
            let id = 'new'+this.nodes.length;
            this.nodes.push({
                id: id, x:0, y:0, children: {}
            })
        },
        opendrop(node){
            this.nodes.forEach(function (node) {
                node.isOpen = false;
            })
            node.isOpen = !node.isOpen;

            if (node.isStartpoint){
                if (!node.childOrientation){
                    node.childOrientation = []
                }
                Object.keys(node.children).forEach(key => {
                    if ( !node.childOrientation.find(x=> x.node == key) ){
                        node.childOrientation.push({node: key})
                    }
                });

            }

            this.selectedNode = node;
            this.drawGraph(node)
        },
        openServicePoint(node){
            this.selectedServicePoint = node;
        },
        deleteNode(node){
            this.$delete(this.nodes, node);
            this.nodes = this.nodes.filter(x=> x.id != node.id);
            this.drawGraph();
        },
        addServicePoint(){
            this.servicePoints.push({
                type: this.activeServicePoints, position: {x:0,y:0}
            })
            this.servicePoints.forEach(function (element, index) {
                element.id = index;
            })

        },
        deleteServicePoint(point){
            // this.$delete(this.servicePoints, point)
            this.servicePoints = this.servicePoints.filter(x=> x.id != point.id);
        },
        addChild(node){
            node.children[this.newChild] = 1
            this.newChild = ''
            this.drawGraph(this.selectedNode)
        },
        deleteChild(node, child){
            let children = node.children;
            Vue.delete(children, child)
            this.drawGraph();
        },
        masterBump(axis, direction){
            this.nodes.forEach(function (node) {
                node[axis] += direction;
            })
        },
        save(){
            let v = this;
            localStorage.setItem("nodes", JSON.stringify(this.nodes));
            // axios.post('https://www.shoppingcityseiersberg.at/wp-json/rubikon/v1/navi', this.nodes
            // ).then(response => {
            //     console.log (response)
            // }, error => {
            //     console.log('axios error' + error)
            // });
        },
        load(){
          this.nodes = JSON.parse(localStorage.getItem("nodes")  )
        },
        drawGraph(hoverNode = null){
            if (hoverNode && hoverNode.type == 'mouseleave'){
                return;
            }
            console.log(hoverNode);
            let v = this;
            var nodeStage = new Konva.Stage({
                container: 'nodemap',
                width: this.mapWidth,
                height: this.mapHeight
            });

            // then create layer
            var text = new Konva.Layer();
            this.nodes.forEach(node => {
                var nodelabel = new Konva.Text({
                    x: node.x,
                    y: node.y,
                    text: node.id,
                    fontSize: 10,
                    fontFamily: 'Calibri',
                    fill: 'black',
                });
                text.add(nodelabel);

                Object.keys(node.children).forEach(function(key) {
                    let child = v.getNode(key);

                    let lineColor = 'blue'
                    let trans = 0.5
                    let width = 1
                    if (hoverNode && hoverNode.id == node.id ){
                        lineColor = 'red'
                        trans = 1;
                        width = 5
                    }

                    if (child){
                        var nodeline = new Konva.Line({
                            points: [node.x, node.y, child.x, child.y ],
                            stroke: lineColor,
                            strokeWidth: width,
                            opacity: trans
                        });
                        text.add(nodeline);
                    }

                });
            });


            nodeStage.add(text);
            text.draw();
        },

        getNode: function (node) {
            return this.nodes.find(x=>x.id==node)
        }
    }
}
</script>

<style lang="scss">
@import "../../styles/variables";
#app.NaviConfig {
    transform: scale(1) !important;
    width: auto !important;
    height: auto !important;

    #NavigationPaths {
        line {
            stroke: black !important;
        }
    }

    #conva {
        position: absolute;
        top: 0;
        left: 0;
    }

  #Parking {
    opacity: 1 !important;
  }

    .naviConfig {
        display: block !important;
    }

    .maps {
        display: flex;
    }

    .map {
        position: relative;
        height: auto;
        margin-top: 40px;
        svg {
            width: 800px;
        }
        .node {
            color: white;

            touch-action: none;
            user-select: none;
            position: absolute;
            display: flex;

            .drag {
                $size: 30px;
                width: $size;
                height: $size;
                border-radius: 100%;
                display: block;
                background: #01a888;
                opacity: 0.6;
                border: 8px solid white;
                box-sizing: border-box;
                &.isopen {
                    background: red !important;
                }
                &.isstart {
                    background: #a84401;
                }
            }



            input {
                width: 36px;;
            }

        }
    }

    .pop {
        position: absolute;
        background: #b8b8b8;
        width: 100px;
        display: none;
        font-size: 12px;
        padding: 5px;
        z-index: 999;
        color: white;
        &.open {
            display: block;
        }
    }

    .controls {
        display: flex;
        .panel {
            background: #dedede;
            padding: 20px;
            margin: 20px;

            h4{
                margin-top: 0;
            }

            input {
                &[type=text] {
                    width: 60px;
                }
            }
        }
    }
    .output {
        font-size: 10px;
        padding: 20px;
    }

}

</style>


